import * as csc from 'cornerstone-core';
// @ts-ignore
import * as csm from 'cornerstone-math';
import { getNormalizedOrth, getNormalizedVector } from './geometryHelper';
import { DisplayableImageData, Point } from 'app/interfaces/Image';

type CanvasOffset = Point;
type Image = DisplayableImageData;
export const mapFloatCoordsToPixels = ({ x, y }: Point, el: csc.EnabledElement): Point => ({
  x: el.image.width * x,
  y: el.image.height * y,
});

export const getDistanceForImage = (image: Image, p1: Point, p2: Point): number => {
  const columnPixelSpacing = image.columnPixelSpacing || 1;
  const rowPixelSpacing = image.rowPixelSpacing || 1;

  const ratio = columnPixelSpacing / rowPixelSpacing;
  const p1WithSpacing = { x: p1.x, y: p1.y * ratio };
  const p2WithSpacing = { x: p2.x, y: p2.y * ratio };
  return csm.point.distance(p1WithSpacing, p2WithSpacing);
};

export const mapFloatCanvasCoordsToPixels = ({ x, y }: Point, el: csc.EnabledElement): Point => {
  const { canvas } = el;
  return csc.canvasToPixel(el.element, {
    x: canvas.width * x,
    y: canvas.height * y,
  } as csc.CanvasCoordinate);
};

export const getDistanceForElement = (e: HTMLElement, p1: Point, p2: Point): number => {
  const { image } = csc.getEnabledElement(e);
  return getDistanceForImage(image, p1, p2);
};

export const getCanvasDistance = (e: HTMLElement, p1: Point, p2: Point): number => {
  const p1c = csc.pixelToCanvas(e, p1 as csc.PixelCoordinate);
  const p2c = csc.pixelToCanvas(e, p2 as csc.PixelCoordinate);

  return csm.point.distance(p1c, p2c);
};

export const scaleDistanceToCanvas = (e: HTMLElement, distance: number): number => {
  const viewport = csc.getViewport(e);
  return distance * viewport.scale;
};

export const offsetPixelPointInCanvas = (
  elem: HTMLElement,
  pixelCoords: Point,
  canvasOffset: CanvasOffset
): Point => {
  const canvasCoords = csc.pixelToCanvas(elem, pixelCoords as csc.PixelCoordinate);
  canvasCoords.x += canvasOffset.x;
  canvasCoords.y += canvasOffset.y;
  return csc.canvasToPixel(elem, canvasCoords);
};

export const projectAlongAxis = (
  elem: HTMLElement,
  refPoint: Point,
  p1: Point,
  p2: Point,
  canvasDist: number
) => {
  const proj = getNormalizedVector(
    csc.pixelToCanvas(elem, p1 as csc.PixelCoordinate),
    csc.pixelToCanvas(elem, p2 as csc.PixelCoordinate)
  );
  return offsetPixelPointInCanvas(elem, refPoint, {
    x: proj.x * canvasDist,
    y: proj.y * canvasDist,
  });
};

export const projectPerpendicularToAxis = (
  elem: HTMLElement,
  refPoint: Point,
  p1: Point,
  p2: Point,
  canvasDist: number
): Point => {
  const proj = getNormalizedOrth(
    csc.pixelToCanvas(elem, p1 as csc.PixelCoordinate),
    csc.pixelToCanvas(elem, p2 as csc.PixelCoordinate)
  );
  return offsetPixelPointInCanvas(elem, refPoint, {
    x: proj.x * canvasDist,
    y: proj.y * canvasDist,
  });
};
